// assets
import {
  IconDashboard,
  IconSitemap,
  IconArticle,
  IconAdjustments,
  IconKey,
  IconGardenCart,
  IconUser,
  IconMessage,
  IconBox,
  IconCoin,
  IconChartBar,
  IconList,
  IconCurrencyDollar,
  IconMovie,
  IconBook,
  IconActivity
} from '@tabler/icons-react';

const icons = { IconDashboard, IconSitemap, IconArticle, IconAdjustments, IconKey, IconGardenCart, IconUser, IconMessage, IconBox, IconCoin, IconChartBar, IconList, IconCurrencyDollar, IconMovie, IconBook, IconActivity };

// Menu titles live in locales/*/translation.json under the "menu" namespace.

export const workspaceMenu = {
  id: 'workspace',
  type: 'group',
  minRole: 1,
  children: [
    {
      id: 'dashboard',
      type: 'item',
      url: '/panel/dashboard',
      icon: icons.IconDashboard,
      iconColor: '#4dabf7',
      breadcrumbs: false,
      minRole: 1
    },
    {
      id: 'usage_stats',
      type: 'item',
      url: '/panel/usage_stats',
      icon: icons.IconChartBar,
      iconColor: '#20c997',
      breadcrumbs: false,
      minRole: 1
    },
    {
      id: 'log',
      type: 'item',
      url: '/panel/log',
      icon: icons.IconArticle,
      iconColor: '#63e6be',
      breadcrumbs: false,
      minRole: 1
    }
  ]
};

export const servicesMenu = {
  id: 'services',
  type: 'group',
  minRole: 1,
  children: [
    {
      id: 'chat',
      type: 'item',
      url: '/panel/chat',
      icon: icons.IconMessage,
      iconColor: '#a9e34b',
      breadcrumbs: false,
      minRole: 1
    },
    {
      id: 'video',
      type: 'item',
      url: '/panel/video',
      icon: icons.IconMovie,
      iconColor: '#f783ac',
      breadcrumbs: false,
      minRole: 1
    },
    {
      id: 'token',
      type: 'item',
      url: '/panel/token',
      icon: icons.IconKey,
      iconColor: '#ffa94d',
      breadcrumbs: false,
      minRole: 1
    },
    {
      id: 'model_square',
      type: 'item',
      url: '/panel/model_square',
      icon: icons.IconBox,
      iconColor: '#748ffc',
      breadcrumbs: false,
      minRole: 1
    },
    {
      id: 'api_doc',
      type: 'item',
      url: '/api-docs.html',
      icon: icons.IconBook,
      iconColor: '#ff8787',
      breadcrumbs: false,
      minRole: 1,
      external: true,
      target: true
    }
  ]
};

export const financeMenu = {
  id: 'finance',
  type: 'group',
  minRole: 1,
  children: [
    {
      id: 'topup',
      type: 'item',
      url: '/panel/topup',
      icon: icons.IconGardenCart,
      iconColor: '#ffd43b',
      breadcrumbs: false,
      minRole: 1
    }
  ]
};

export const managementMenu = {
  id: 'management',
  type: 'group',
  minRole: 10,
  children: [
    {
      id: 'channel',
      type: 'collapse',
      icon: icons.IconSitemap,
      iconColor: '#69db7c',
      minRole: 10,
      children: [
        {
          id: 'channelManage',
          type: 'item',
          url: '/panel/channel',
          icon: icons.IconList,
          iconColor: '#69db7c',
          breadcrumbs: false
        },
        {
          id: 'channelPricing',
          type: 'item',
          url: '/panel/channel/pricing',
          icon: icons.IconCoin,
          iconColor: '#69db7c',
          breadcrumbs: false
        },
        {
          id: 'channelStats',
          type: 'item',
          url: '/panel/channel/stats',
          icon: icons.IconChartBar,
          iconColor: '#69db7c',
          breadcrumbs: false
        },
        {
          id: 'availableModels',
          type: 'item',
          url: '/panel/channel/available_models',
          icon: icons.IconBox,
          iconColor: '#69db7c',
          breadcrumbs: false
        },
        {
          id: 'channelTest',
          type: 'item',
          url: '/channel-test.html',
          icon: icons.IconActivity,
          iconColor: '#69db7c',
          breadcrumbs: false,
          external: true,
          target: true
        }
      ]
    },
    {
      id: 'user',
      type: 'collapse',
      icon: icons.IconUser,
      iconColor: '#da77f2',
      minRole: 10,
      children: [
        {
          id: 'userManage',
          type: 'item',
          url: '/panel/user',
          icon: icons.IconUser,
          iconColor: '#da77f2',
          breadcrumbs: false
        },
        {
          id: 'userPricing',
          type: 'item',
          url: '/panel/user/pricing',
          icon: icons.IconCurrencyDollar,
          iconColor: '#da77f2',
          breadcrumbs: false
        }
      ]
    },
    {
      id: 'log_manage',
      type: 'item',
      url: '/panel/log/manage',
      icon: icons.IconArticle,
      iconColor: '#63e6be',
      breadcrumbs: false,
      minRole: 10
    }
  ]
};

export const systemMenu = {
  id: 'system',
  type: 'group',
  minRole: 100,
  children: [
    {
      id: 'setting',
      type: 'item',
      url: '/panel/setting',
      icon: icons.IconAdjustments,
      iconColor: '#74c0fc',
      breadcrumbs: false,
      minRole: 100
    }
  ]
};
